import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { isGetHelpSourceApp } from '../../../../web/utils/statelessUtil';
import { Environment, SourceApps } from '../../../models/constants/constants';
import { IAppState, ServiceRequestPageType } from '../../../models/reduxState';
import { hideRequestCreationTab, resetContactUsFocus, updateUITabViewInfo } from '../../app/appActions';
import {
  getCorrelationId,
  currentUITabViewSelector,
  isMsaSelector,
  isAadSelector,
  isTeamsSelector,
  isGetHelpSelector,
  isBATenantSelector,
  isBusinessAssistUXEnabledSelector,
  getCurrentServiceRequestPageType,
  isOcvEnabledSelector,
} from '../../app/selectors/contactUsSelector';
import { ContactUsFooter } from '../presentationalComponents/ContactUsFooter';
import { setAttachmentError } from '../reduxUpdater/actions/attachmentsActions';
import {
  setUserIsSigningIntoClientApp,
  setAuthInfoForTeams,
  signInUserIntoClientApp,
} from '../reduxUpdater/actions/modalitySectionActions';
import { setDirtyRequest, resetRequestDetailsEditError } from '../reduxUpdater/actions/requestDetailsActions';
import { dispatchBypassThemeRouting, dispatchRedirectForSignInLink, dispatchSignInUser, dispatchSignInUserIntoClientApp, dispatchUserInfoFetch } from '../reduxUpdater/dispatchers/contactUsDispatchers';
import { dispatchUpdateRequest } from '../reduxUpdater/dispatchers/requestDetailsDispatchers';
import { hideContactSupportButtonSelector, isRequestSaveBtnEnabledSelector, showStickyFooterSelector } from '../reduxUpdater/selectors/commonSelectors';
import { isUpdatingRequestSelector, isRequestDetailsEditErrorSelector } from '../reduxUpdater/selectors/requestDetailsSelectors';
import { isRequestClosedSelector, isRequestDetailsEditModeSelector } from '../reduxUpdater/selectors/requestSelector';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  const isRequestClosed = isRequestClosedSelector(state);
  return {
    showOcv: isOcvEnabledSelector(state),
    isSignedIn: state.ContactState.ModalitySectionState.isSignedIn,
    userIsSigningIntoClientApp:
      state.ContactState.ModalitySectionState.isUserIsSigningIntoClientApp,
    appVer: state.GlobalState.appVer,
    sourceApp: state.GlobalState.sourceApp,
    namespace: state.GlobalState.namespace,
    market: state.GlobalState.market,
    redirectForSignInLink:
      state.ContactState.ModalitySectionState.redirectForSignInLink,
    isClientApp: state.GlobalState.environment === Environment.nonAgavePane,
    fixedStickyFooter:
      state.GlobalState.environment === Environment.agavePane ||
      state.GlobalState.environment === Environment.nonAgavePane ||
      state.GlobalState.sourceApp === SourceApps.Teams ||
      state.GlobalState.sourceApp === SourceApps.Teams2 ||
      state.GlobalState.sourceApp === SourceApps.TeamsAdmin ||
      state.GlobalState.sourceApp === SourceApps.TeamsAdmin2 ||
      state.GlobalState.sourceApp === SourceApps.SurfaceApp ||
      state.GlobalState.sourceApp === SourceApps.SurfaceApp2 ||
      state.GlobalState.sourceApp === SourceApps.OfficeDotCom ||
      state.GlobalState.sourceApp === SourceApps.OutlookAdmin ||
      state.GlobalState.sourceApp === SourceApps.LightHouse ||
      state.GlobalState.sourceApp === SourceApps.OneDriveWeb ||
      isGetHelpSourceApp(state.GlobalState.sourceApp),
    environment: state.GlobalState.environment,
    showFooter: showStickyFooterSelector(state, isRequestClosed),
    correlationId: getCorrelationId(state),
    currentUITabView: currentUITabViewSelector(state),
    userInfoFetchEnded:
      state.ContactState.ModalitySectionState.userInfoFetchEnded,
    userInfo: state.ContactState.ModalitySectionState.userInfo,
    hideContactUsButton: hideContactSupportButtonSelector(state),
    isRequestDetailsEditMode: isRequestDetailsEditModeSelector(state),
    isRequestClosed: isRequestClosed,
    isRequestSaveBtnEnabled: isRequestSaveBtnEnabledSelector(state),
    isUpdatingRequest: isUpdatingRequestSelector(state),
    isRequestDetailsEditError: isRequestDetailsEditErrorSelector(state),
    isBATenant: isBATenantSelector(state),
    isMsa: isMsaSelector(state),
    isAad: isAadSelector(state),
    isTeams: isTeamsSelector(state),
    isGetHelp: isGetHelpSelector(state),
    isBusinessAssistUXEnabled: isBusinessAssistUXEnabledSelector(state),
    isCurrentPageSignIn: getCurrentServiceRequestPageType(state.ContactState.ModalitySectionState) === ServiceRequestPageType.SignInSection,
    dialogId: state.ContactState.SelfHelpAlchemyState.dialogId,
    themeRoutingResponse: state.ContactState.SelfHelpAlchemyState.alchemyResults,
    isContactSupportButtonDisabled: state.ContactState.ModalitySectionState.isSignedIn && state.NavState.requestCreationTabHidden
  };
};

const mapDispatchToProps = {
  updateUITabViewInfo,
  dispatchRedirectForSignInLink,
  dispatchSignInUser,
  dispatchSignInUserIntoClientApp,
  setUserIsSigningIntoClientApp,
  setAuthInfoForTeams,
  dispatchUserInfoFetch,
  dispatchUpdateRequest,
  setDirtyRequest,
  resetRequestDetailsEditError,
  setAttachmentError,
  signInUserIntoClientApp,
  resetContactUsFocus,
  dispatchBypassThemeRouting,
};

export const ContactUsFooterContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(ContactUsFooter, getContactUsStyles));
